import { Button } from "@/components/ui/button";
import { MenuItem } from "./types";
import { ModeToggle } from "../ModeToggle";

interface DesktopNavProps {
  user: any;
  menuItems: MenuItem[];
  handleNavigation: (path: string) => void;
  handleSignOut: () => void;
}

export const DesktopNav = ({ user, menuItems, handleNavigation, handleSignOut }: DesktopNavProps) => {
  return (
    <nav className="hidden md:flex items-center space-x-4 lg:space-x-6">
      {user ? (
        <>
          {menuItems.map((item) => (
            <Button
              key={item.path}
              variant="ghost"
              onClick={() => handleNavigation(item.path)}
              className="text-sm lg:text-base text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200"
            >
              {item.icon || item.label}
            </Button>
          ))}
          <ModeToggle />
          <Button 
            variant="outline" 
            onClick={handleSignOut} 
            className="text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200"
          >
            Sign Out
          </Button>
        </>
      ) : (
        <>
          <ModeToggle />
          <Button 
            variant="ghost" 
            onClick={() => handleNavigation("/login")} 
            className="text-gray-900 hover:text-primary active:text-secondary transition-colors duration-200"
          >
            Login
          </Button>
          <Button 
            onClick={() => handleNavigation("/register")}
            className="hover:text-primary active:text-secondary transition-colors duration-200"
          >
            Register
          </Button>
        </>
      )}
    </nav>
  );
};